import Action from 'redux/helpers/createAction'
const name = 'keywordSavingsOverview'

export const getDomainKeywordSavingsOverview = Action(
  name + '/GET_DOMAIN_KEYWORD_SAVINGS_OVERVIEW_DATA',
  (domainId, filters) => ({
    domainId,
    filters
  })
)

export const getDomainKeywordSavingsOverviewSuccess = Action(
  name + '/GET_DOMAIN_KEYWORD_SAVINGS_OVERVIEW_DATA_SUCCESS',
  (savingsOverview, id) => ({
    savingsOverview,
    id
  })
)

export const getDomainKeywordSavingsOverviewFailure = Action(
  name + '/GET_DOMAIN_KEYWORD_SAVINGS_OVERVIEW_DATA_FAILURE',
  error => ({
    error
  })
)
